export const feedFilter = [
    {
        name: 'All',
        resource: 'none',
        subresource: 'none',
    },
    {
        name: 'Auditions',
        resource: 'created a gig',
        subresource: 'gig',
    },
    {
        name: 'Campaigns',
        resource: 'created a contest',
        subresource: 'campaign',
    },
    {
        name: 'What creators are saying',
        resource: 'shared a thougth',
        subresource: 'thougth',
    },
    {
        name: 'Modelling',
        resource: 'created a gig',
        subresource: 'gig',
    },
    {
        name: 'Videos',
        resource: 'created a project',
        subresource: 'project',
    },
    {
        name: 'Creators Shares',
        resource: 'shared a thougth',
        subresource: 'project',
    },
];
